module.exports = __webpack_public_path__ + "img/icon-role.3c22eb2.svg";